import gql from 'graphql-tag';

export const getMOCEventsForAOR = gql`
  query getMOCEventsForAOR($aorId: String, $turnoverIncomingCompleted: String) {
    getMOCEventsForAOR(
      aorId: $aorId
      turnoverIncomingCompleted: $turnoverIncomingCompleted
    ) {
      id
      title
      MOCEventType {
        id
        name
        enabled
      }
      startDt
      endDt
      MOCEventAORs {
        id
      }
      MOCEventAcknowledgements {
        id
        Contact {
          id
          firstName
          lastName
        }
        acknowledged
        completedDt
      }
      parentMocId
      historyId
      createdAt
    }
  }
`;
